const formatDate = (date: string) => {
  const months = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre",
  ];
  const fullDate = new Date(date.replace(/-/g, "/"));
  const day = fullDate.getDate();
  const month = fullDate.getMonth();

  return day + " de " + months[month];
};

export default formatDate;
